import LoadingSpinner from '@passkeys/ui/loading-spinner';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import BuyForm from '@/ui/components/buy-form/index.js';
import Page from '@/ui/components/page';
import exodus from '@/ui/exodus';
import selectors from '@/ui/flux/selectors';
import useBuyAvailability from '@/ui/hooks/use-buy-availability.js';
import useExpandedEffect from '@/ui/hooks/use-expanded-effect';
import useLocation from '@/ui/hooks/use-location';
import showUnavailableModal from '@/ui/modals/fiat-unavailable-modal';
import type { BuyPageLocationState } from './types.js';

const PRIMARY_SUCCESS_ACTION = {
  label: 'Buy more',
  route: '/buy',
};

const ALTERNATIVE_SUCCESS_ACTION = {
  label: 'Back to home',
  route: '/',
};

const BuyPage = () => {
  const location = useLocation<BuyPageLocationState>();
  const { token: initialToAssetName, referrer = 'unknown' } =
    location.state ?? {};

  const ratesLoading = useSelector<unknown, boolean>(selectors.rates.loading);

  const { value: isAvailable, loading: isAvailabilityLoading } =
    useBuyAvailability();

  const loading = ratesLoading || isAvailabilityLoading;

  useEffect(() => {
    if (isAvailabilityLoading || isAvailable) {
      return;
    }

    showUnavailableModal();
  }, [isAvailable, isAvailabilityLoading]);

  useExpandedEffect(() => {
    exodus.analytics.track({
      event: 'OnRampView',
      properties: {
        origin: referrer,
      },
    });
  }, [referrer]);

  return (
    <Page className="flex flex-col pb-8">
      {loading ? (
        <LoadingSpinner className="mx-auto my-20 text-black theme-dark:text-white" />
      ) : (
        isAvailable && (
          <BuyForm
            variant="fiat"
            initialToAssetName={initialToAssetName}
            referrer={referrer}
            submitButtonClassName="mx-4"
            primarySuccessAction={PRIMARY_SUCCESS_ACTION}
            alternativeSuccessAction={ALTERNATIVE_SUCCESS_ACTION}
          />
        )
      )}
    </Page>
  );
};

export default BuyPage;
